import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchFavoriteDictionary } from './queryFunctions';

export function getFavoriteDictionary() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchFavoriteDictionary>>>(
    queryKeys.favoriteChannelsDictionary,
  );
}
